const getExpConfig = (key) => window?.__EXPERIENCE_PROPS__?.expConfiguration?.[key];

export default getExpConfig;
